const ValidateType = {
	Default: 0,
	Active: 1,
	Error: 2
};

export default ValidateType;